import { create } from '../../feathersFunctionalWrapper';

const isDraftDocumentUrl = (url) => url && url.includes('draft_documents');

const extractPath = (url) => {
  const match = url.match(/(uploads\/draft_documents\/[^?]+)/);
  return match ? match[1] : url;
};

const openDocumentWithSignedUrl = async (rawUrl, organizationId) => {
  if (!isDraftDocumentUrl(rawUrl)) {
    window.open(rawUrl, '_blank', 'noopener,noreferrer');
    return;
  }

  const path = extractPath(rawUrl);
  const response = await create('turbotenant-document-token', { organizationId, path });
  window.open(response.url, '_blank', 'noopener,noreferrer');
};

export default openDocumentWithSignedUrl;
